import moment from 'moment'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { appBannerManagementApi, pageSetupManagementApi } from '@services/api'

export const fetchList = createAsyncThunk(
  'appBannerManagement/fetchList',
  async (params: TAppBannerManagement.FetchList, { rejectWithValue }) => {
    try {
      const response = await appBannerManagementApi.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchCodeAndNameList = createAsyncThunk(
  'appBannerManagement/fetchCodeAndNameList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await pageSetupManagementApi.fetchCodeAndNameList()
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const create = createAsyncThunk(
  'appBannerManagement/create',
  async (data: TAppBannerManagement.TState['bannerUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await appBannerManagementApi.create(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const update = createAsyncThunk(
  'appBannerManagement/update',
  async (data: TAppBannerManagement.TState['bannerUpsert']['data'], { rejectWithValue }) => {
    try {
      const response = await appBannerManagementApi.update(data)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchSingle = createAsyncThunk(
  'appBannerManagement/fetchSingle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await appBannerManagementApi.fetchSingle(id)
      response.data.data.startDate = moment(response.data.data.startDate).format('YYYY-MM-DD')
      response.data.data.endDate = moment(response.data.data.endDate).format('YYYY-MM-DD')
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
